import DataType from '@opsbase/lib-datatype/DataType';
import doNothing from '@opsbase/lib-general/utils/doNothing';
import i18n from '@opsbase/lib-i18n';
import Pages from '@opsbase/lib-pages';
import Palette from '@opsbase/lib-palette';
import useReportDelete from '@opsbase/react-gql-hooks/report/useReportDelete';
import useView from '@opsbase/web-ctrl-view/useView';
import useViewRegistryActions from '@opsbase/web-ctrl-view/useViewRegistryActions';
import ConfirmDialog from '@opsbase/web-dialogs/ConfirmDialog';
import useNav from '@opsbase/web-nav/useNav';
import useParams from '@opsbase/web-nav/useParams';
import useNotificationActions from '@opsbase/web-notification/useNotificationActions';
import Text from '@opsbase/web-ui/Text';
import React, { useCallback } from 'react';
export function ReportDeleteDialog() {
    const { viewId } = useParams();
    const { replaceTo } = useNav();
    const { raise } = useNotificationActions();
    const view = useView(viewId);
    const { deleteView } = useViewRegistryActions();
    const deleteReport = useReportDelete();
    const handleAction = useCallback(async () => {
        return raise(deleteReport({ id: viewId }).then(() => {
            setTimeout(() => deleteView(viewId), 500);
        }), i18n.t('savedview-delete-successful'))
            .then(() => {
            const type = view.type;
            if (type === DataType.OP) {
                replaceTo(Pages.OPS_LOG, { viewId: 'default' });
            }
            else if (type === DataType.ISSUE) {
                replaceTo(Pages.ISSUES_LOG, { viewId: 'default' });
            }
            else if (type === DataType.OPDEFINITION) {
                replaceTo(Pages.OP_DEFINITIONS, { viewId: 'default' });
            }
            else {
                replaceTo(Pages.DASHBOARD);
            }
        })
            .catch(doNothing);
    }, [deleteView, deleteReport, view.type, viewId, raise, replaceTo]);
    return (React.createElement(ConfirmDialog, { onConfirm: handleAction, disableGoBackOnConfirm: true, agreeText: i18n.t('delete'), notAgreeText: i18n.t('cancel'), color: Palette.error },
        React.createElement(Text, null, i18n.t('confirm-savedview-delete'))));
}
export default ReportDeleteDialog;
